'use client';
import SliderSection from './components/SliderSection';
import CenterButton from './components/CenterButton';
import BlurOverlays from './components/BlurOverlays';
import HoverArea from './components/HoverArea';
import { useSliderState } from './hooks/useSliderState';
import CenterBlurOverlay from './components/CenterBlurOverlay';
import { AnimatePresence } from 'motion/react';

interface SliderContent {
  leftSection: React.ReactNode;
  rightSection: React.ReactNode;
}

interface SliderProps {
  content: SliderContent;
}

export const BeforeAfterSlider = ({ content }: SliderProps) => {
  const { state, handlers } = useSliderState();
  const { hoveredSection, expandedSection, previousExpandedSection, hasExpanded } = state;
  const { onHover, onSectionClick, onCenterButtonClick } = handlers;
  const { leftSection, rightSection } = content;

  return (
    <div className="flex justify-center items-center relative">
      <AnimatePresence>
        <CenterButton
          hoveredSection={hoveredSection}
          expandedSection={expandedSection}
          hasExpanded={hasExpanded}
          onClick={onCenterButtonClick}
        />
        <CenterBlurOverlay expandedSection={expandedSection} />
        <div className="w-full h-fit select-none">
          <SliderSection
            side="right"
            expandedSection={expandedSection}
            previousExpandedSection={previousExpandedSection}
          >
            {rightSection}
          </SliderSection>

          <SliderSection side="left" expandedSection={expandedSection}>
            {leftSection}
          </SliderSection>

          {!expandedSection && (
            <>
              <BlurOverlays hoveredSection={hoveredSection} expandedSection={expandedSection} />
              <HoverArea
                side="left"
                onMouseEnter={() => onHover('left')}
                onMouseLeave={() => onHover(null)}
                onClick={() => onSectionClick('left')}
                expandedSection={expandedSection}
                hasExpanded={hasExpanded}
              />
              <HoverArea
                side="right"
                onMouseEnter={() => onHover('right')}
                onMouseLeave={() => onHover(null)}
                onClick={() => onSectionClick('right')}
                expandedSection={expandedSection}
                hasExpanded={hasExpanded}
              />
            </>
          )}
        </div>
      </AnimatePresence>
    </div>
  );
};
